module.exports = __webpack_public_path__ + "img/40_00_000_320.955858c4.jpg";